// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.why_choose_main {
  display: flex;
  justify-content: center;
}

.why_choose {
  width: 90%;
}

.why_choose_row {
  margin-bottom: 35px;
}

.five_box_top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.five_box_bottom {
  display: flex;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  gap: 32px;
}
.five_box_top_left{
  position: relative;
  background-color: #faf9fb;
  padding: 15px;
  gap: 0px;
  border-radius: 16px;
  border: 1px solid #e9d9fb;
  transition: border 0.3s ease-in-out;
}

.five_box_top_left:hover{
  border-width: 2px 2px 1px 2px;
  border-color: #974DD9;
}

.five_box_top_right{
  position: relative;
  background-color: #faf9fb;
  padding: 15px;
  gap: 0px;
  border-radius: 16px;
  border: 1px solid #e9d9fb;
  transition: border 0.3s ease-in-out;
}

.five_box_top_right:hover{
  border-width: 2px 2px 1px 2px;
  border-color: #974DD9;
}


.five_box_bottom_left,
.five_box_bottom_mid,
.five_box_bottom_right {
  background-color: #faf9fb;
  padding: 15px;
  gap: 0px;
  border-radius: 16px;
  border: 1px solid #e9d9fb;
  transition: border 0.3s ease-in-out;
}

.five_box_bottom_left:hover{
  border-width: 2px 2px 2px 2px;
  border-color: #974DD9;
}


.five_box_bottom_mid:hover{
  border-width: 2px 2px 2px 2px;
  border-color: #974DD9;
}

.five_box_bottom_right:hover{
  border-width: 2px 2px 2px 2px;
  border-color: #974DD9;
}

.five_box_top_left,
.five_box_top_right {
  width: 40%;
}

.five_box_bottom_left,
.five_box_bottom_mid,
.five_box_bottom_right {
  width: 26%;
}

.five_box_top_img_div {
  position: relative;

}

.five_box_top_img {
  width: 95%;
  height: 100%;
  border-radius: 16px;
  transition: opacity 0.9s ease-in-out;
}




.five_box_top_img_hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 95%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.9s ease-in-out;
}

.five_box_top_img_div:hover .five_box_top_img {
  opacity: 0;
}

.five_box_top_img_div:hover .five_box_top_img_hover {
  opacity: 1;
}

.five_box_top_img_arrow {
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 25px;
}

.five_box_top_h2 {
  font-family: Sora;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0.15px;
  text-align: left;
}

.five_box_top_p {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
}

.why_choose_heading {
  font-family: Sora;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  text-align: center;
  color: #0e121b;
  padding: 20px;
  border-radius: 8px;
}

.why_choose_para {
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  color: #99a0ae;
  margin: 10px 0;
}

.whychoose_btn {
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px 40px;
  border: 2px solid #e837ff !important;
  color: #7511d3;
  letter-spacing: 1.25px;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
}

.whychoose_btn_down {
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px 40px;
  border: 2px solid #e837ff !important;
  color: #7511d3;
  letter-spacing: 1.25px;
  background: transparent;
  font-size: 10px;
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
}

.custom-card {
  width: 20rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: background-image 0.3s ease;
}

.custom-card:hover {
  background-image: linear-gradient(
    to right,
    rgba(117, 17, 211, 0.8),
    rgba(105, 26, 111, 0.8)
  );
}

.custom-card:hover .custom_title {
  color: rgb(255, 255, 255) !important;
}

.custom-card:hover .custom-text {
  color: rgb(255, 255, 255) !important;
}

.custom-card:hover .custom-button {
  color: #ffffff !important;
}

.custom-img {
  opacity: 0.9;
  padding: 10px;
}

.custom_title {
  color: #363636 !important;
  font-size: 24px !important;
  font-family: "Poppins", sans-serif !important;
}

.custom-text {
  font-size: 16px;
  font-family: "Poppins", sans-serif !important;
}

.custom-button {
  background-color: rgb(222, 222, 222);
  align-items: right !important;
  background: transparent !important;
  color: #7511d3 !important;
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  border: none !important;
}

.whychoose_download_btn {
  margin-top: 50px;
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  height: 100%;
}

.whychoose_btn_download {
  display: inline-block;
  margin-right: 50px;
  padding: 15px 80px;
  border: 2px solid #e837ff !important;
  color: #7511d3;
  letter-spacing: 1.25px;
  background: transparent;
  font-size: 10px;
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
}

@media (max-width: 992px) {
  .why_choose_heading {
    font-size: 40px;
  }
  .why_choose_para {
    font-size: 18px;
  }
  .whychoose_btn {
    font-size: 14px;
    padding: 10px 30px;
  }
  .custom-card {
    width: 100%;
  }
  .custom_title {
    font-size: 20px;
  }
  .custom-text {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .why_choose_heading {
    font-family: Sora;
font-size: 28px;
font-weight: 600;
line-height: 36px;
text-align: center;

  }
  .why_choose_para {
    font-family: Inter;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: center;

  }
  .five_box_top_h2{
    font-family: Sora;
font-size: 18px;
font-weight: 600;
line-height: 22px;
letter-spacing: 0.15000000596046448px;
text-align: left;

  }
  .five_box_top_p{
    font-family: Inter;
font-size: 16px;
font-weight: 400;
line-height: 26px;
text-align: left;

  }

  .five_box_top,
  .five_box_bottom {
    flex-direction: column;
    gap: 20px;
  }

  .five_box_top_left,
  .five_box_top_right,
  .five_box_bottom_left,
  .five_box_bottom_mid,
  .five_box_bottom_right {
    width: 90%;
    margin-bottom: 20px;
  }

  .why_choose_main {
    flex-direction: column;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/WhyChoose/whychooseus.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;;AAGA;;;EAGE,yBAAyB;EACzB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;;AAGA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;AACtC;;;;;AAKA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,yBAAyB;EACzB,6CAA6C;EAC7C,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;AACrB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;;EAEhB;EACA;IACE,kBAAkB;AACtB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;;EAEhB;EACA;IACE,iBAAiB;AACrB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,qCAAqC;AACrC,gBAAgB;;EAEd;EACA;IACE,kBAAkB;AACtB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,gBAAgB;;EAEd;;EAEA;;IAEE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;;;IAKE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":[".why_choose_main {\n  display: flex;\n  justify-content: center;\n}\n\n.why_choose {\n  width: 90%;\n}\n\n.why_choose_row {\n  margin-bottom: 35px;\n}\n\n.five_box_top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n}\n\n.five_box_bottom {\n  display: flex;\n  margin-top: 20px;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n}\n.five_box_top_left{\n  position: relative;\n  background-color: #faf9fb;\n  padding: 15px;\n  gap: 0px;\n  border-radius: 16px;\n  border: 1px solid #e9d9fb;\n  transition: border 0.3s ease-in-out;\n}\n\n.five_box_top_left:hover{\n  border-width: 2px 2px 1px 2px;\n  border-color: #974DD9;\n}\n\n.five_box_top_right{\n  position: relative;\n  background-color: #faf9fb;\n  padding: 15px;\n  gap: 0px;\n  border-radius: 16px;\n  border: 1px solid #e9d9fb;\n  transition: border 0.3s ease-in-out;\n}\n\n.five_box_top_right:hover{\n  border-width: 2px 2px 1px 2px;\n  border-color: #974DD9;\n}\n\n\n.five_box_bottom_left,\n.five_box_bottom_mid,\n.five_box_bottom_right {\n  background-color: #faf9fb;\n  padding: 15px;\n  gap: 0px;\n  border-radius: 16px;\n  border: 1px solid #e9d9fb;\n  transition: border 0.3s ease-in-out;\n}\n\n.five_box_bottom_left:hover{\n  border-width: 2px 2px 2px 2px;\n  border-color: #974DD9;\n}\n\n\n.five_box_bottom_mid:hover{\n  border-width: 2px 2px 2px 2px;\n  border-color: #974DD9;\n}\n\n.five_box_bottom_right:hover{\n  border-width: 2px 2px 2px 2px;\n  border-color: #974DD9;\n}\n\n.five_box_top_left,\n.five_box_top_right {\n  width: 40%;\n}\n\n.five_box_bottom_left,\n.five_box_bottom_mid,\n.five_box_bottom_right {\n  width: 26%;\n}\n\n.five_box_top_img_div {\n  position: relative;\n\n}\n\n.five_box_top_img {\n  width: 95%;\n  height: 100%;\n  border-radius: 16px;\n  transition: opacity 0.9s ease-in-out;\n}\n\n\n\n\n.five_box_top_img_hover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 95%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.9s ease-in-out;\n}\n\n.five_box_top_img_div:hover .five_box_top_img {\n  opacity: 0;\n}\n\n.five_box_top_img_div:hover .five_box_top_img_hover {\n  opacity: 1;\n}\n\n.five_box_top_img_arrow {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 25px;\n  height: 25px;\n}\n\n.five_box_top_h2 {\n  font-family: Sora;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  letter-spacing: 0.15px;\n  text-align: left;\n}\n\n.five_box_top_p {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  text-align: left;\n}\n\n.why_choose_heading {\n  font-family: Sora;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  text-align: center;\n  color: #0e121b;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.why_choose_para {\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 28px;\n  text-align: center;\n  color: #99a0ae;\n  margin: 10px 0;\n}\n\n.whychoose_btn {\n  margin-right: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px 40px;\n  border: 2px solid #e837ff !important;\n  color: #7511d3;\n  letter-spacing: 1.25px;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.whychoose_btn_down {\n  margin-right: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px 40px;\n  border: 2px solid #e837ff !important;\n  color: #7511d3;\n  letter-spacing: 1.25px;\n  background: transparent;\n  font-size: 10px;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.custom-card {\n  width: 20rem;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  transition: background-image 0.3s ease;\n}\n\n.custom-card:hover {\n  background-image: linear-gradient(\n    to right,\n    rgba(117, 17, 211, 0.8),\n    rgba(105, 26, 111, 0.8)\n  );\n}\n\n.custom-card:hover .custom_title {\n  color: rgb(255, 255, 255) !important;\n}\n\n.custom-card:hover .custom-text {\n  color: rgb(255, 255, 255) !important;\n}\n\n.custom-card:hover .custom-button {\n  color: #ffffff !important;\n}\n\n.custom-img {\n  opacity: 0.9;\n  padding: 10px;\n}\n\n.custom_title {\n  color: #363636 !important;\n  font-size: 24px !important;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.custom-text {\n  font-size: 16px;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.custom-button {\n  background-color: rgb(222, 222, 222);\n  align-items: right !important;\n  background: transparent !important;\n  color: #7511d3 !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  border: none !important;\n}\n\n.whychoose_download_btn {\n  margin-top: 50px;\n  display: flex;\n  align-items: center !important;\n  justify-content: center !important;\n  height: 100%;\n}\n\n.whychoose_btn_download {\n  display: inline-block;\n  margin-right: 50px;\n  padding: 15px 80px;\n  border: 2px solid #e837ff !important;\n  color: #7511d3;\n  letter-spacing: 1.25px;\n  background: transparent;\n  font-size: 10px;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n@media (max-width: 992px) {\n  .why_choose_heading {\n    font-size: 40px;\n  }\n  .why_choose_para {\n    font-size: 18px;\n  }\n  .whychoose_btn {\n    font-size: 14px;\n    padding: 10px 30px;\n  }\n  .custom-card {\n    width: 100%;\n  }\n  .custom_title {\n    font-size: 20px;\n  }\n  .custom-text {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .why_choose_heading {\n    font-family: Sora;\nfont-size: 28px;\nfont-weight: 600;\nline-height: 36px;\ntext-align: center;\n\n  }\n  .why_choose_para {\n    font-family: Inter;\nfont-size: 16px;\nfont-weight: 400;\nline-height: 24px;\ntext-align: center;\n\n  }\n  .five_box_top_h2{\n    font-family: Sora;\nfont-size: 18px;\nfont-weight: 600;\nline-height: 22px;\nletter-spacing: 0.15000000596046448px;\ntext-align: left;\n\n  }\n  .five_box_top_p{\n    font-family: Inter;\nfont-size: 16px;\nfont-weight: 400;\nline-height: 26px;\ntext-align: left;\n\n  }\n\n  .five_box_top,\n  .five_box_bottom {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .five_box_top_left,\n  .five_box_top_right,\n  .five_box_bottom_left,\n  .five_box_bottom_mid,\n  .five_box_bottom_right {\n    width: 90%;\n    margin-bottom: 20px;\n  }\n\n  .why_choose_main {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
